<template>
  <Page
    :loading="isLoadingPage"
    :spinning="isSpinning"
    class="base-table"
  >
    <PageTitle>Globale noter</PageTitle>
    <p v-if="getAllGlobalNotes.length === 0">
      Der er ingen global noter oprettet.
    </p>

    <section>
      <TableTopFilterAndSearch
        button-label="Opret note"
        :search-term="searchTerm"
        @input-search="searchTerm = $event"
        :filter-by="filterBy"
        button-link="global-notes.create"
        @input-filter="filterBy = $event"
      />

      <TableRowHeader :sort="sort" />

      <TableRowItems
        v-if="getAllGlobalNotes.length"
        :list="getFilteredGlobalNotes"
        link="global-notes.single"
      />
    </section>
  </Page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Page from '../Page.vue';
import TableRowItems from '../../components/TableRowItems.vue';
import TableRowHeader from '../../components/TableRowHeader.vue';
import TableTopFilterAndSearch from '../../components/TableTopFilterAndSearch.vue';
import Pageload from '../../mixins/Pageload';
import sortByKeyAndDirection from '../../mixins/sortByKeyAndDirection';

export default {
    name: 'GlobalNotes',
    mixins: [Pageload, sortByKeyAndDirection],
    components: {
        TableTopFilterAndSearch, TableRowHeader, TableRowItems, Page,
    },

    data() {
        return {
            searchTerm: '',
            filterBy: 'all',
        };
    },
    computed: {
        ...mapGetters('globalnotes', [
            'getAllGlobalNotes',
        ]),
        getFilteredGlobalNotes() {
            return this.getAllGlobalNotes
                .filter(note => note.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1)
                .filter((note) => {
                    switch (this.filterBy) {
                    case 'active':
                        return !note.deleted;
                    case 'deleted':
                        return note.deleted;
                    default:
                        return true;
                    }
                })
                .sort(this.sortByKeyAndDirection);
        },
    },
    methods: {
        ...mapActions('globalnotes', [
            'loadGlobalNotes',
        ]),

    },
    async created() {
        try {
            await this.loadGlobalNotes();
            this.pageloaded();
        } catch (error) {
            //
        }
    },
};
</script>
